import { useEffect, useState } from "react";
import { getFaculty } from "../Service/Api";
import InnerHaeder from '../Component/InnerHaeder'
import Highlights from '../Component/Highlights'
import Footer from'../Component/Footer'
import { Link } from 'react-router-dom'
import HeadTag from '../Component/HeadTags'
const OurFaculty = () => { 
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
      const fetchData = async () => {
          try {
            const response = await getFaculty();
            const faculty = Array.isArray(response)
              ? response
              : response?.data || response?.faculty || [];

            const sortedData = [...faculty].sort(
              (a, b) => Number(a.order) - Number(b.order)
            );

            setFilteredData(sortedData);
          } catch (fetchError) {
            console.error("Unable to load faculty data:", fetchError);
            setError("Unable to load faculty details. Please try again later.");
          } finally {
            setIsLoading(false);
          }
      };
      fetchData();
  }, []);
  return (
    <>
    <HeadTag title="Our Faculty" />
     <Highlights/>
     <InnerHaeder/>
     <div className="inner_page">
     <div className="container-fluid flwidth">
       <div className="bgimage">
        <h5><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link><span> About Us  <i className="fas fa-angle-right"></i> Our Faculty </span></h5>
        <h2>Our Faculty</h2>
        </div>
        <div className="innertable">
<table width="100%">
<tbody>
<tr>
<th>S. No.</th>
<th>Employee's Name</th>
<th>Designation</th>
<th>Category</th>
</tr>

{filteredData.map((item, index) => (
  <tr key={item._id || index}>
    <td>{index + 1}</td>
    <td>{item.name}</td>
    <td>{item.designation || item.desgination}</td>
    <td>{item.qualification}</td>
  </tr>
 ))}
{isLoading && (
  <tr><td colSpan="4">Loading faculty details...</td></tr>
)}
{!isLoading && error && (
  <tr><td colSpan="4">{error}</td></tr>
)}
{!isLoading && !error && filteredData.length === 0 && (
  <tr><td colSpan="4">No faculty details available.</td></tr>
)}
{/* <tr>
<td>1</td>
<td>ABCD</td>
<td>ABCD</td>
<td>Manager</td>
</tr>
<tr>
<td>1</td>
<td>ABCD</td>
<td>ABCD</td>
<td>Manager</td>
</tr>
<tr>
<td>1</td>
<td>ABCD</td>
<td>ABCD</td>
<td>Manager</td>
</tr>
<tr>
<td>1</td>
<td>ABCD</td>
<td>ABCD</td>
<td>Manager</td>
</tr>
<tr>
<td>1</td>
<td>ABCD</td>
<td>ABCD</td>
<td>Manager</td>
</tr>
<tr>
<td>1</td>
<td>ABCD</td>
<td>ABCD</td>
<td>Manager</td>
</tr>
<tr>
<td>1</td>
<td>ABCD</td>
<td>ABCD</td>
<td>Manager</td>
</tr> */}
</tbody></table>
</div>
        </div>
        </div>
     <Footer/>
    </>
  )
}

export default OurFaculty
